import * as Yup from "yup";
import {
  MIN_MAX_FIELDS_VALIDATION,
  LENGTH_VALIDATION,
  VALIDATE_FILES_SIZE_AND_COUNT,
  GOOGLE_BUSINESS_PROFILE_LINK_VALIDATION_SCHEMA,
  WEBSITE_LINK_VALIDATION_SCHEMA,
  EDITOR_LENGTH_VALIDATION,
  GREATER_THAN_ZERO_VALIDATION,
  NOT_EMPTY_ARRAY_VALIDATION,
  FILE_SIZE_VALIDATION_OPTIONAL,
  FILE_SIZE_VALIDATION,
  VALIDATE_FILES_SIZE_AND_COUNT_OPTIONAL,
} from "src/constants/formValidation";
import { CloneFields } from "../types";

const COMPANY_TURNOVER_VALIDATION_SCHEMA = MIN_MAX_FIELDS_VALIDATION(
  CloneFields.companyTurnoverMin,
  CloneFields.companyTurnoverMax
);
const MONTHLY_INCOME_VALIDATION_SCHEMA = MIN_MAX_FIELDS_VALIDATION(
  CloneFields.monthlyIncomeMin,
  CloneFields.monthlyIncomeMax
);

export const EDIT_CLONE_VALIDATION_SCHEMA = Yup.object().shape({
  [CloneFields.cloneType]: Yup.string().required("required"),
  [CloneFields.companyName]: LENGTH_VALIDATION(1, 300),
  [CloneFields.companyPresentation]: VALIDATE_FILES_SIZE_AND_COUNT_OPTIONAL(
    50,
    5
  ),
  [CloneFields.googleProfile]:
    GOOGLE_BUSINESS_PROFILE_LINK_VALIDATION_SCHEMA.nullable(),
  [CloneFields.industry]: Yup.string().required("required"),
  [CloneFields.website]: WEBSITE_LINK_VALIDATION_SCHEMA.optional().nullable(),
  [CloneFields.describeProduct]: EDITOR_LENGTH_VALIDATION(10, 3000),
  [CloneFields.advantages]: LENGTH_VALIDATION(5, 1500),
  [CloneFields.investmentForStart]: GREATER_THAN_ZERO_VALIDATION,
  [CloneFields.employees]: Yup.string().required("required"),
  [CloneFields.yearsOnMarket]: Yup.string().required("required"),
  [CloneFields.customersCount]: Yup.string().required("required"),
  [CloneFields.companyTurnoverMin]: COMPANY_TURNOVER_VALIDATION_SCHEMA.min,
  [CloneFields.companyTurnoverMax]: COMPANY_TURNOVER_VALIDATION_SCHEMA.max,
  [CloneFields.cloneCost]: GREATER_THAN_ZERO_VALIDATION,
  [CloneFields.activities]: EDITOR_LENGTH_VALIDATION(10, 3000),
  [CloneFields.companyClients]: Yup.string().required("required"),
  [CloneFields.patentsBrandsText]: Yup.string().optional(),
  [CloneFields.supportBuyer]: LENGTH_VALIDATION(5, 50),
  [CloneFields.informationSold]: NOT_EMPTY_ARRAY_VALIDATION,
  [CloneFields.monthlyIncomeMin]: MONTHLY_INCOME_VALIDATION_SCHEMA.min,
  [CloneFields.monthlyIncomeMax]: MONTHLY_INCOME_VALIDATION_SCHEMA.max,
  [CloneFields.logo]: FILE_SIZE_VALIDATION_OPTIONAL(5),
  [CloneFields.mainPhoto]: FILE_SIZE_VALIDATION_OPTIONAL(5),
  [CloneFields.prohibitedCountries]: Yup.array().optional(),
  [CloneFields.additionalInformation]: Yup.string().optional(),
});

export const CREATE_CLONE_VALIDATION_SCHEMA = Yup.object().shape({
  ...EDIT_CLONE_VALIDATION_SCHEMA.fields,
  [CloneFields.companyPresentation]: VALIDATE_FILES_SIZE_AND_COUNT(50, 5),
  [CloneFields.logo]: FILE_SIZE_VALIDATION(5),
  [CloneFields.mainPhoto]: FILE_SIZE_VALIDATION(5),
});
